export default {
	firstName: '',
	lastName: '',
	company: '',
	country: 'United States',
	address: '',
	city: '',
	state: '',
	zip: '',
	phoneNumber: '',
	email: '',
	electronicFulfillment: false,
	additionalNotes: '',
	cardNumber: '',
	expirationDate: '',
	cardCode: ''
};
